export default __webpack_public_path__ + "static/media/Rotating Table (2).bbc840c4.jpg";